import React from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';

const Base_ = (props) => (
  <div style={Object.assign({} ,{
      color: props.alternateColor ?
             props.muiTheme.palette.alternateTextColor :
              props.muiTheme.palette.textColor,
      fontSize: props.fontSize,
      marginTop: props.marginTop,
      marginBottom: props.marginBottom
    }, props.style)}>
    {props.children}
  </div>
)
const Base = muiThemeable()(Base_)

const Display4 = (props) => (
  <Base alternateColor={props.alternateColor}
        fontSize="112px">{props.children}</Base>
)

const Display3 = (props) => (
  <Base alternateColor={props.alternateColor}
        fontSize="56px">{props.children}</Base>
)

const Display2 = (props) => (
  <Base alternateColor={props.alternateColor}
        fontSize="45px">{props.children}</Base>
)

const Display1 = (props) => (
  <Base style={Object.assign({}, {
    fontSize:"34px",
    marginBottom:"1em"
  }, props.style)}
  alternateColor={props.alternateColor}
        >{props.children}</Base>
)

const Headline = (props) => (
  <Base alternateColor={props.alternateColor}
        style={Object.assign({}, {
          fontSize:"24px",
          marginBottom:"1em"
        }, props.style)}>
    {props.children}</Base>
)

const Title = (props) => (
  <Base alternateColor={props.alternateColor}
        marginTop={props.marginTop}
        marginBottom={props.marginBottom}
        style={Object.assign({}, {
          fontSize:"20px"
        }, props.style)}>{props.children}</Base>
)

const Subheading = (props) => (
  <Base alternateColor={props.alternateColor}
        style={Object.assign({}, {
          fontSize:"16px",
          marginBottom:"1em"
        }, props.style)}>{props.children}</Base>
)

const Body2 = (props) => (
  <Base alternateColor={props.alternateColor}
        fontSize="14px">{props.children}</Base>
)

const Body1 = (props) => (
  <Base alternateColor={props.alternateColor}
        style={Object.assign({}, {
          fontSize:"14px"
        }, props.style)}>{props.children}</Base>
)

const Caption = (props) => (
  <Base alternateColor={props.alternateColor}
        fontSize="12px">{props.children}</Base>
)

export { Display4, Display3, Display2, Display1, Headline, Title,
         Subheading, Body2, Body1, Caption };



// WEBPACK FOOTER //
// ./src/Typography.js